import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FolioGuia } from "app/features/componentes/folioguia";
import { SelectorSimpleFactory } from "app/features/selectores/logic";

type Entity = models.FiltroTurno;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => void;
}



const LimiteGuias = SelectorSimpleFactory([25, 50, 100, 200, 300, 500, 1000, 2000], x => x, x => "" + x);

/**
* Componente para editar un FiltroTurno
*/
export class FiltroTurnoComponent extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {};
    }


    /**
     Establece la hora desde a la primer hora del día 12:00 am
     */
    private onFechaDesdeChange = (x: Date | null, key: keyof Entity) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(0, 0, 0, 0);
            const viejo = this.props.value;
            const cambioFecha: Partial<Entity> = { [key]: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<Entity> = { [key]: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }

    /**
    Establece la hora hasta a la ultima hora del día 11:59 pm
    */
    private onFechaHastaChange = (x: Date | null, key: keyof Entity) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(23, 59, 59);
            const viejo = this.props.value;
            const cambioFecha: Partial<Entity> = { [key]: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<Entity> = { [key]: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Number = getField(kea.Number);
        const Datetime = getField(kea.DateTime);
        const Cliente = getField(selectores.Cliente);
        const Sucursal = getField(selectores.Sucursal);
        const Usuario = getField(selectores.Usuario);
        const Folio = getField(FolioGuia);
        const StatusFacturacion = getField(selectores.StatusFacturacion);
        const StatusGuia = getField(selectores.StatusGuia);
        const SiNo = getField(selectores.SiNo);
        const Acuse = getField(selectores.TipoAcuse);
        const Limite = getField(LimiteGuias);
        return (
            <div>
                {kea.autogrid(2, [
                    <Sucursal field="IdSucursal" label="Sucursal:" />,
                    <Usuario field="IdUsuario" label="Usuario:" />,
                    <Datetime field="FechaEntradaInicio" onChange={x => this.onFechaDesdeChange(x, "FechaEntradaInicio")} label="Fecha entrada inicio:" />,
                    <Datetime field="FechaEntradaFinal" onChange={x => this.onFechaHastaChange(x, "FechaEntradaFinal")} label="Fecha entrada final:" />,
                    <Datetime field="FechaSalidaInicio" onChange={x => this.onFechaDesdeChange(x, "FechaSalidaInicio")} label="Fecha salida inicio:" />,
                    <Datetime field="FechaSalidaFinal" onChange={x => this.onFechaHastaChange(x, "FechaSalidaFinal")} label="Fecha salida final:" />,
                    <Limite field="Limite" label="Limite" />,
                ])}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/turnos/list/filtro.tsx